<template>
	<div class="flex gap-4">
		<div
			class="w-0.5 shrink-0"
			:class="{ 'bg-fill-secondary': !active, 'bg-[#FFD326]': active }"
		></div>
		<div
			class="text-sm"
			:class="{ 'text-label-secondary': !active, 'text-label-primary': active }"
		>
			{{ text }}
		</div>
	</div>
</template>
<script setup lang="ts">
defineProps<{
	active?: boolean
	text: string
}>()
</script>
